import { render, staticRenderFns } from "./mv-edit-frame.vue?vue&type=template&id=b85518b6&scoped=true"
import script from "./mv-edit-frame.vue?vue&type=script&lang=js"
export * from "./mv-edit-frame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b85518b6",
  null
  
)

export default component.exports